// Meta Pixel — initializes the Facebook/Meta Pixel(s) and tracks the initial PageView.
// Mirrors the official Meta Pixel base code snippet.

// Every pixel listed here is initialized and receives the PageView event.
const PIXEL_IDS = ['1443459693942372', '28576272985370836'] as const

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel(): void {
  // Guard against double init (e.g. React StrictMode / hot reloads) and SSR.
  if (initialized || typeof window === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode!.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  // Initialize every pixel, then fire a single PageView (it reports to all of them).
  PIXEL_IDS.forEach((id) => window.fbq('init', id))
  window.fbq('track', 'PageView')

  // <noscript> fallback for users with JavaScript disabled — one per pixel.
  const noscript = document.createElement('noscript')
  PIXEL_IDS.forEach((id) => {
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`
    noscript.appendChild(img)
  })
  document.body.appendChild(noscript)
}
